'use client';
import { OurSlots } from '@shared/icons';
import { twMerge } from '@shared/themes';
import { useMediaQuery } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { type ComponentProps, Children } from 'react';
import { DoubleCarousel } from '../../Carousel/index';

type OurGamesProps = ComponentProps<'section'> & {
  children: React.ReactNode;
  showMoreButton: React.ReactNode;
  title: string;
  description: string;
  namespace: string;
};

function OurGames({ className, showMoreButton, children, title, description, namespace, ...props }: OurGamesProps) {
  const t = useTranslations(namespace);
  const isLargeScreen = useMediaQuery(`(width >= 1440px)`);
  const childrenArray = Children.toArray(children);
  const topCarouselLine = isLargeScreen ? childrenArray : childrenArray.slice(0, childrenArray.length / 2);
  const bottomCarouselLine = isLargeScreen ? childrenArray.toReversed() : childrenArray.slice(childrenArray.length / 2);

  return (
    <section className={twMerge('dark ll-grid-container gap-y-6 bg-secondary py-8', className)} data-testid="our-games-section" {...props}>
      <div className="ll-container-inner text-foreground">
        <OurSlots size="extra-large" className="mb-4 text-accent-green" aria-label={t(`alt_text`)} />
        <h2 className="mb-4 heading-5" data-track-title={title}>
          {title}
        </h2>
        <p data-track-description={description}>{description}</p>
      </div>
      <DoubleCarousel topCarouselLine={topCarouselLine} bottomCarouselLine={bottomCarouselLine} showMoreButton={showMoreButton} className="ll-container-full" />
    </section>
  );
}

export { OurGames };
